import React, { Component } from "react";
import {
  TextInput,
  StyleSheet,
  View,
  Button,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Modal,
  FlatList,
  Platform,
} from "react-native";
import { I18n } from "aws-amplify";
import { useDispatch } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import UnderLine from "../AnimatedUnderLine";
import { Ionicons } from "@expo/vector-icons";
import IntlPhoneInput from "react-native-intl-phone-input";
import PhoneInput from "react-native-phone-number-input";
import { AntDesign } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import GenericButton from "../GenericButton";
import Colors from "../../utilities/Color.js";

import { Amplify, Auth } from "aws-amplify";
// import awsConfig from "./aws-exports";
import getEnvVars from "../../enviroment";

const awsConfig = getEnvVars().awsConfig;

import { user_login } from "../../redux/actions/UserActions";

function ButtonClickCheckFunction() {
  //Alert.alert("Button Clicked");
}

Amplify.configure(awsConfig);

import {
  withAuthenticator,
  Authenticator,
  AmplifyTheme,
} from "aws-amplify-react-native";

export default function LoginSavedUser(props) {
  const [username, onChangeUserText] = React.useState("");
  const [password, onChangePassText] = React.useState("");
  const [phone, onChangePhoneText] = React.useState("");
  const [value, setValue] = React.useState("");
  const [valueCode, setValueCode] = React.useState("61");
  const [formattedValue, setFormattedValue] = React.useState("");
  const platform = Platform.OS;

  const [errorMsg, onErrorMsg] = React.useState("");

  const [showHidePassword, onChangePasswordShow] = React.useState(true);

  const dispatch = useDispatch();
  const navigation = useNavigation();

  var formMode = "";
  if (typeof props.mode !== undefined) {
    formMode = props.mode;
  }
  var savedUsername = "";
  if (typeof props.savedUsername !== undefined) {
    savedUsername = props.savedUsername;
  }

  const signIn = async (email, password, mode = "e") => {
    if (password === "") {
      onErrorMsg("Please enter a password");
    } else {
      try {
        const res = await Auth.signIn(email, password);
        const u = await Auth.currentAuthenticatedUser();
        const epoch = new Date().getTime();
        const refId = Math.floor(epoch / 10);
        const incRefId = u.attributes["custom:refererId"] || "";
        const userobj = {
          memberId: res.username,
          referFriendId: refId.toString(),
          refererId: incRefId,
          givenName: res.attributes.given_name,
          familyName: res.attributes.family_name,
          phone: "0",
          email: "",
        };
        if (mode === "e") {
          userobj.email = email;
        } else if (mode === "p") {
          userobj.phone = email;
        }
        // const r = await Auth.updateUserAttributes(u, {
        //   "custom:auraNumber": res.username,
        // });
        // axi.post("TestingPartners/createMember", userobj);
        // dispatch({ type: "USER_LOGIN", user: res });

        // before finishing login, save login type info
        const savedLogin = {
          mode: mode,
          username: email,
        };
        await AsyncStorage.setItem("loginMemory", JSON.stringify(savedLogin));

        user_login(res);
        return res;
      } catch (error) {
        onErrorMsg(error.message);
      }
    }
  };

  return (
    // <Authenticator />
    // TESTpassword!42
    <>
      <View style={styles.HbuttonBar}>
        <TouchableOpacity
          style={styles.HbackButtonStyle}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="md-arrow-back" size={20} style={styles.HbackArrow} />
        </TouchableOpacity>
        <View>
          <Text style={styles.HTextStyle}></Text>
        </View>
      </View>

      <View style={styles.container}>
        <View>
          <View style={styles.infoBox}>
            <Text style={styles.textStyleSubHeader}>Welcome back!</Text>
            <Text style={styles.textLogin}>Last log in: {savedUsername}</Text>
            <View style={styles.PasswordinputContainer}>
              <View style={styles.Passwordinput}>
                <TextInput
                  style={styles.textInput}
                  onChangeText={(text) => onChangePassText(text)}
                  value={password}
                  placeholder={"Password"}
                  secureTextEntry={showHidePassword}
                />
              </View>
              <View style={styles.PasswordToggle}>
                <TouchableOpacity
                  style={styles.iconContainer}
                  onPress={() =>
                    showHidePassword
                      ? onChangePasswordShow(false)
                      : onChangePasswordShow(true)
                  }
                >
                  {showHidePassword ? (
                    <AntDesign color="#aaaaaa" name="eyeo" size={20} />
                  ) : (
                    <AntDesign color="#aaaaaa" name="eye" size={20} />
                  )}
                </TouchableOpacity>
              </View>
            </View>

            <Text style={styles.TextStyleError}></Text>
            <View style={{ flexDirection: "column" }}>
              <TouchableOpacity
                style={styles.SubmitButtonStyleNone}
                activeOpacity={0.5}
                /* swap link based on mode? */
                onPress={() =>
                  navigation.navigate("ForgotPassword", {
                    formMode: formMode,
                    autofill: savedUsername,
                  })
                }
              >
                <Text style={styles.TextStyleResend}>FORGOT PASSWORD</Text>
              </TouchableOpacity>
            </View>
          </View>
          <GenericButton
            buttonText="LOG IN"
            onPress={() => signIn(savedUsername, password, formMode)}
          />
          <Text style={styles.TextStyleError}>{errorMsg}</Text>
        </View>
        <View style={{ marginTop: 10 }}>
          <GenericButton
            buttonColor={null}
            borderWidth={1}
            borderColor={Colors.DARKGRAY}
            buttonText="LOG IN ANOTHER WAY"
            onPress={() => navigation.navigate("LoginModeChoice")}
          />
        </View>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  phoneModalSafeArea: {
    //backgroundColor: 'blue',
    height: "100%",
  },
  textStyleSubHeader: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 16,
    paddingTop: 10,
    paddingBottom: 10,
  },

  phoneModalContainer: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 48,
  },

  phoneModalClose: {
    alignItems: "flex-start",
    justifyContent: "center",
    marginBottom: 20,
    height: 40,
    paddingLeft: 5,
  },

  phoneModalIcon: {
    paddingLeft: 5,
  },

  phoneModalText: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 18,
  },

  phoneModalInputContainer: {
    flexDirection: "row",
  },

  phoneModalInputField: {
    color: "#000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 18,
    marginBottom: 20,
    width: "100%",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    paddingBottom: 5,
  },

  phoneModalList: {
    height: "80%",
  },

  phoneModalListItem: {
    flexDirection: "row",
    //marginBottom: 20,
    alignItems: "center",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    paddingBottom: 10,
    paddingTop: 10,
  },

  phoneModalListItemFlag: {
    //flex:2,
    width: 60,
  },
  phoneModalListIemFlagText: {
    fontSize: 22,
  },

  phoneModalListItemCountry: {
    flex: 15,
  },

  phoneModalListItemDailcode: {
    flex: 1,
    minWidth: 30,
  },

  phoneModalListIemText: {
    color: "#000",
    fontFamily: "montserrat-regular",
    fontSize: 15,
  },

  TextStyleOR: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    marginTop: 15,
  },

  TextStyleResend: {
    padding: 5,
    fontSize: 12,
    color: "#337599",
    fontWeight: "bold",
    textAlign: "center",
  },

  SubmitButtonStyleNone: {
    marginTop: 0,
    // marginLeft: 50,
    // marginRight: 50,
    marginTop: 5,
    // paddingBottom: 15,
    borderRadius: 30,
    justifyContent: "center",
  },
  container: {
     flex: 1,
     justifyContent: "space-between",
  },

  infoBox: {
    height: 250,
    width: 350,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginBottom: 20,
    padding: 20,
    alignSelf: "center",
  },

  inputContainer: {
    paddingTop: 15,
  },

  PasswordinputContainer: {
    paddingTop: 15,
    flexDirection: "row",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
  },

  iconContainer: {
    //paddingLeft: 0,
    //paddingRight: 30,
    paddingTop: 10,
    //width: 50,
  },

  Passwordinput: {
    flex: 7,
  },

  PasswordToggle: {
    flex: 1,
    paddingLeft: 45,
    paddingRight: 0,
    //paddingTop: 10,
  },

  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: "none",
      },
    }),
    //borderColor: "#CCCCCC",
    //borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },

  EmailtextInput: {
    ...Platform.select({
      web: {
        outlineStyle: "none",
      },
    }),
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },

  linkStyle: {
    paddingTop: 20,
  },

  TextStyleLink: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  TextStyleLinkLogin: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  TextStyle: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  SubmitButtonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
    width: 350,
    alignSelf: "center",
  },

  textInputNoUnderline: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    // flex: 1,
    // flexDirection: "row"
  },
  flexStyle: {
    flex: 1,
    flexDirection: "row",
  },
  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
  },

  textLogin: {
    textAlign: "center",
    marginBottom: 30,
  },

  TextStyleError: {
    color: "#FFFFFF",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 16,
    paddingTop: 20,
  },

  LinkBar: {
    width: 70,
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 10,
  },

  LinkBarNext: {
    width: "52%",
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "flex-end",
    marginTop: 10,
    marginBottom: 0,
  },

  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
  },

  HbuttonBarConf: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30,
  },

  HbackArrow: {
    color: "#fff",
  },

  HbackArrowBlack: {
    color: "#000",
  },

  HbackButtonStyle: {
    marginTop: 0,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },

  HTextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  TextStyleRight: {
    color: "#ffffff",
    textAlign: "right",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },
});
